const imageCache = {};

const CURSOR_PTZ_ICON_URL = {
    DEFAULT: 'Crosshair.svg',
    ZOOM_IN: 'zoom-in-icon.png',
    ZOOM_OUT: 'zoom-out-icon.png',
    LOADING: 'loading.png',
};
const preloadImages = (urls) => {
    urls.forEach((url) => {
        const img = new Image();
        img.src = url;
        imageCache[url] = img;
    });
};

preloadImages([CURSOR_PTZ_ICON_URL.DEFAULT, CURSOR_PTZ_ICON_URL.ZOOM_IN, CURSOR_PTZ_ICON_URL.ZOOM_OUT, CURSOR_PTZ_ICON_URL.LOADING]);

export const CURSOR_STYLE = {
    DEFAULT: `url(${imageCache[CURSOR_PTZ_ICON_URL.DEFAULT].src}) 10 10, auto`,
    ZOOM_IN: `url(${imageCache[CURSOR_PTZ_ICON_URL.ZOOM_IN].src}), zoom-in`,
    ZOOM_OUT: `url(${imageCache[CURSOR_PTZ_ICON_URL.ZOOM_OUT].src}), zoom-out`,
    LOADING: `url(${imageCache[CURSOR_PTZ_ICON_URL.LOADING].src}), wait`,
};

export const ZOOM_MODE = {
    ZOOM_IN: 'zoomIn',
    ZOOM_OUT: 'zoomOut',
};

export const MOUSE_BUTTON = {
    LEFT: 0,
    RIGHT: 2,
    NONE: undefined,
};

export const REGION_STYLES = {
    default: {
        lineColor: '#3889FA',
        fillColor: 'rgb(41 124 239 /26%)',
        lineWidth: 3,
    },
    [ZOOM_MODE.ZOOM_IN]: {
        lineColor: '#3889FA',
        fillColor: 'rgb(41 124 239 /26%)',
        lineWidth: 1,
    },
    [ZOOM_MODE.ZOOM_OUT]: {
        lineColor: '#F57C00',
        fillColor: 'rgb(245 124 0 /26%)',
        lineWidth: 1,
    },
};

export const PTZ_REQUEST = {
    PATH: {
        PTZ_REGION: () => '/camera/ptz/full-control',
        PTZ_RECENTER: () => '/camera/ptz/recenter',
        PTZ_PRESET: (cameraId, presetKey) => `/camera/${cameraId}/ptz/presets/${presetKey}`,
        PTZ_FULL_ZOOM_IN: (cameraId) => `/camera/${cameraId}/full-zoom/MAX`,
        PTZ_FULL_ZOOM_OUT: (cameraId) => `/camera/${cameraId}/full-zoom/MIN`,
    },
    STATUS: {
        IN_PROGRESS: 'inProgress',
        SUCCESS: 'success',
        ERROR: 'error',
    },
    NOTIFICATION_TIMEOUT_MS: {
        IN_PROGRESS: 5000,
        RESULT: 2000,
    },
};
